import { toCamelCaseKeys } from '@/js/lib/helper/localize-keys';
import jsonData from './material.json';

interface MaterialData {
  materialId: number;
  slug: string;
  name: string;
}

const materialData: MaterialData[] = toCamelCaseKeys(jsonData);

export const materials = (): MaterialData[] => materialData;

export const material = ({ materialId }: { materialId: number }) => materialData.find((m) => m.materialId === materialId);
